/**
 * 前后端API交互
 */

import axios, { AxiosRequestConfig } from 'axios';
import { bridge } from 'util/index';

const instance = axios.create({
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    },
});

// Add a request interceptor
instance.interceptors.request.use(async function (config) {
  if (bridge.isInApp()) {
    const xxzId = await bridge.getXxzId();
    config.headers['x-xxzid'] = xxzId;
  }
  // Do something before request is sent
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

export const service = {
    get(url: string, config?: AxiosRequestConfig) {
        return instance.get(url, config);
    },

    post(url: string, data?: any, config?: AxiosRequestConfig) {
        return instance.post(url, data, config);
    }
};
